import React from "react";
import * as R from "ramda";

import BISProcessHistory from "./BisProcessHistory";
import UpsertProcessHistory from "./UpsertProcessHistory";
import ACCGProcessHistory from "./ACCGProcessHistory";
import MergeEntityProcessHistory from "./MergeEntityProcessHistory";
import LobTerminationProcessHistory from "./LobTerminationProcessHistory";
import EDDProcessHistory from "./EDDProcessHistory";
import UpdateEntityHistory from "./UpdateEntityHistory";

const ProcessHistoryComponent = ({ data, processRelayId }) => {
    const component = R.pathOr(
        false,
        ["process", "processHistory", "component"],
        data
    );

    const entityUlid = R.pathOr("", ["entity", "key", "ulid"], data);

    switch (component) {
        case "BISProcessHistory":
            return (
                <BISProcessHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                />
            );
        case "UpsertProcessHistory":
            return (
                <UpsertProcessHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                />
            );
        case "ACCGProcessHistory":
            return (
                <ACCGProcessHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                />
            );
        case "MergeEntityProcessHistory":
            return (
                <MergeEntityProcessHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                />
            );
        case "LOBTerminationProcessHistory":
            return (
                <LobTerminationProcessHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                    entityUlid={entityUlid}
                />
            );
        case "EDDProcessHistory":
            return (
                <EDDProcessHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                />
            );
        case "UpdateIndividualHistory":
        case "UpdateOrganisationHistory":
            return (
                <UpdateEntityHistory
                    schema={data.EntitySchema}
                    processRelayId={processRelayId}
                />
            );
        default:
            return null;
    }
};

export default ProcessHistoryComponent;
